import { useFormContext } from 'react-hook-form'
import useConfig from 'modules/config/state/use-config'
import useOrder from 'modules/order/state/order/use-order'
import { useTranslation } from 'next-i18next'
import OrderContactQuestionField from './contact-question-field'
import { OrderContactSlice } from 'modules/order/state/contact/contact-types'

import InputField from 'modules/ui/molecules/FormComponents/InputField'

interface OrderContactQuestions2Props {
  showRequired: boolean
}

const OrderContactQuestions2 = ({ showRequired }: OrderContactQuestions2Props) => {
  const config = useConfig()
  const order = useOrder()
  const form = useFormContext()
  const { t } = useTranslation()

  const {
    contact: { isPhoneRequired },
  } = order

  const fieldError = (fieldName: string) =>
    form.formState.errors[fieldName] as { message: string } | undefined

  return (
    <>
      {config.questions.contact
        .filter((q) => q.tag && ['prefix', 'middle_name', 'suffix'].indexOf(q.tag) === -1)
        .map((question) =>
          question.tag === 'homephone' && showRequired === question.is_required ? (
            <InputField
              id="phone"
              type="tel"
              key={question.id}
              label={t('OrderContactQuestions2.homePhone.label', 'Primary phone')}
              error={fieldError('phone')}
              required={isPhoneRequired}
              autoComplete="tel"
              dataId="contact-phone-input"
            />
          ) : (
            <OrderContactQuestionField
              key={question.id}
              showRequired={showRequired}
              fieldName={question.tag as keyof OrderContactSlice}
            />
          ),
        )}
    </>
  )
}

export default OrderContactQuestions2
